import { type PopupCandidatesResponse } from '@hooks-api/types/apiResponse'

interface getNextPopupIndexProps {
  popups: PopupCandidatesResponse['data']['popups']
  canShowPopupAtIndex: (index: number) => boolean
}

/**
 * 優先尋找 must_show 屬性為 true，且符合顯示條件的彈窗，若找到則直接回傳該索引
 * 若無 must_show 為 true 的彈窗，則從所有符合顯示條件且 must_show 為 false 的彈窗中隨機選一個回傳
 */
export const getNextPopupIndex = (props: getNextPopupIndexProps): number | null => {
  const { popups, canShowPopupAtIndex } = props
  if (!popups?.length) return null
  // 所有可用的彈窗集合
  const candidates = popups
    .map((popup, index) => ({ popup, index }))
    .filter(({ index }) => canShowPopupAtIndex(index))

  const mustShowCandidates = candidates.filter(({ popup }) => popup?.must_show)
  const fallbackCandidates = candidates.filter(({ popup }) => !popup?.must_show)

  if (mustShowCandidates.length > 0) {
    const random = mustShowCandidates[Math.floor(Math.random() * mustShowCandidates.length)]
    return random?.index ?? null
  }

  if (fallbackCandidates.length > 0) {
    const random = fallbackCandidates[Math.floor(Math.random() * fallbackCandidates.length)]
    return random?.index ?? null
  }

  return null
}
